import { createStandardAction } from 'typesafe-actions';

export const setIsFindARoomBtnPresent = createStandardAction(
  'SET_IS_FIND_A_ROOM_BTN_PRESENT',
)<boolean>();
